<template>
  <base-section
  id="venue"
  >
    <v-container>
    <base-section-heading
    title="Event Location"
    color="red"
    align="left"
    :toColor="true"
    >

DDECS'25 will be held in the <strong>Campus Lyon Tech La Doua
</strong>
(<a href="https://www.universite-lyon.fr/campus-life/campus-overview/campus-map/">campus map</a>), in Lyon. <br /> <br />

    </base-section-heading>
    <!--
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        :src="slide.src"
        contain
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        />
      </v-carousel-item>
    </v-carousel>
    -->
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Venue',

    data: () => ({
      slides: [

      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
